import { ButtonsGroup, DialogActions, Divider, Icon, textOverflowEllipsisMixin } from "@evergis/ui";
import styled from "styled-components";
import { AttributesBlockCheckbox } from "../../../DialogComponents/Attributes/styled";
import {
  QueryAttributeActions,
  QueryAttributeContainer,
  QueryAttributesContainer,
} from "../../../EditResource/components/QueryLayerResource/styled";
import { DialogContent } from "../../../SelectResources/styled";

export const TitleButtonsContainer = styled.div`
  margin-left: 1rem;
`;

export const TableAttributesContainer = styled(QueryAttributesContainer)`
  margin-top: 0.5rem;

  ${AttributesBlockCheckbox} {
    margin: 0 0 1rem 1rem;
  }
`;

export const TableAttributeContainer = styled(QueryAttributeContainer)`
  gap: 0;
  height: 3rem;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;

export const TableAttributeMeta = styled.div`
  display: flex;
  width: 100%;
  margin-right: 1rem;
  margin-left: 0.375rem;
  align-items: center;
  gap: 0 0.25rem;
  font-size: 14px;

  ${Icon}:after {
    color: ${({ theme }) => theme.palette.textSecondary};
  }
`;

export const TableAttributeActions = styled(QueryAttributeActions)`
  gap: 0;
`;

export const StyledDivider = styled(Divider)`
  height: 1rem;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;

export const StyledDialogContent = styled(DialogContent)`
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
`;

export const ResourceName = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.textSecondary};
  ${textOverflowEllipsisMixin}
`;

export const ResourceNameInfo = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  margin-top: 2px;
  gap: 0 0.25rem;
`;

export const StyledButtonGroup = styled(ButtonsGroup)`
  button {
    font-size: 14px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
`;

export const StyledDialogActions = styled(DialogActions)`
  align-items: center;
  flex-shrink: 0;
  margin-top: auto;
  padding: 1.5rem 3rem;
  width: 100%;
  box-sizing: border-box;
`;
